import { Component, Injectable, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { InvoiceData, PaymentMethod, SOAPPaymentRequest } from './CustomModels/SOAPPaymentRequest';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { SOAPRecurringPaymentRequest } from './CustomModels/SOAPRecurringPaymentRequest';
import { DeleteRecurringPaymentRequest } from './CustomModels/DeleteRecurringPaymentRequest';
import { AzureTokenService } from './azure-token.service';

@Injectable({
  providedIn: 'root'
})
export class AciPaymentService {

  paymentResposne :any;
  SOAPPaymentRequest :SOAPPaymentRequest = new SOAPPaymentRequest();
  SOAPRecurringPaymentRequest: SOAPRecurringPaymentRequest = new SOAPRecurringPaymentRequest();
  DeleteRecurringPaymentRequest: DeleteRecurringPaymentRequest = new DeleteRecurringPaymentRequest();
  invoiceList:Array<any> = new Array();
  totalamount: string ='';
  ban : string ='';
  showLoader = false;

  azureData:any;
  zipcode:any;

  constructor(private http: HttpClient,public datepipe: DatePipe, public azureService: AzureTokenService) {
    
    var data = JSON.parse(localStorage.getItem("InvoiceList")||"[]");
    if(data.invoices){
      var List = data.invoices;
      List.forEach((element:any) => {
        this.invoiceList.push(element);
      });
    }
    console.log(this.invoiceList.length);
    if (this.invoiceList.length > 0)
      this.zipcode = data.invoices[0]['zipCode'].substring(0,5);
    this.totalamount =  data.totalAmounttoPay;
    this.ban = data.ban;

    this.azureData = azureService.getAzureTokenData();
   }

  pay(token:any,paymenttype:any,recurringFalg:any,isHistorical?: boolean): Observable<any>{
    this.SOAPPaymentRequest.speedFrameToken = token;
    this.SOAPPaymentRequest.amount = Number.parseFloat(this.totalamount);
    this.SOAPPaymentRequest.creditAccount =this.ban;
    this.SOAPPaymentRequest.debitName = this.azureData['name'];
    this.SOAPPaymentRequest.email = this.azureData['emails'][0];
    this.SOAPPaymentRequest.recurring = recurringFalg;
    this.SOAPPaymentRequest.debitZip = this.zipcode;
    this.SOAPPaymentRequest.paymentMethod.paymentType = paymenttype;

    var bpno = "";
    if(this.invoiceList.length > 0){
      this.invoiceList.forEach((ele:any)=>{
        console.log(ele);
        var invoiceData = new InvoiceData();
        invoiceData.amount = ele.editedAmountToPay;
        invoiceData.currency = ele.currency;
        invoiceData.invoiceNo = ele.invoice_id;
        invoiceData.bpno = ele.bpNo;
        invoiceData.cano = ele.caContract;
        invoiceData.cno  = "";
        bpno = ele.bpNo
        this.SOAPPaymentRequest.invoiceData.push(invoiceData);
      })
     }
    this.SOAPPaymentRequest.paymentMethod.bpno = bpno;
    this.SOAPPaymentRequest.isSledCustomer = this.invoiceList[0] && this.invoiceList[0].isSledCustomer;
    let logTraceJSON: any = { 'eventSource': 'paymentProcessingSOAP', 'payload': this.SOAPPaymentRequest, 'ban': this.ban, 'invoiceData': JSON.stringify(this.SOAPPaymentRequest.invoiceData), 'email': this.azureData['emails'][0], 'amount': Number.parseFloat(this.totalamount), 'paymentMethodId': this.SOAPPaymentRequest.speedFrameToken };
    const headers = new HttpHeaders({
        'X-Log-Trace': JSON.stringify(logTraceJSON),
    });
    this.http.post(environment.serverURL+ environment.pgURI + "payment/soap/pay",this.SOAPPaymentRequest, {headers}).pipe((res:any)=>{
      console.log(res);
      this.paymentResposne= res;
      return this.paymentResposne;
    });
    return this.paymentResposne;
  }

  payHistorical(token: any, paymenttype: any, recurringFalg: any): Observable<any> {
    this.SOAPPaymentRequest.speedFrameToken = token;
    this.SOAPPaymentRequest.amount = Number.parseFloat(this.totalamount);
    this.SOAPPaymentRequest.creditAccount = this.ban;
    this.SOAPPaymentRequest.debitName = this.azureData['name'];
    this.SOAPPaymentRequest.email = this.azureData['emails'][0];
    this.SOAPPaymentRequest.recurring = recurringFalg;
    this.SOAPPaymentRequest.debitZip = this.zipcode;
    this.SOAPPaymentRequest.paymentMethod.paymentType = paymenttype;

    var bpno = localStorage.getItem("ban") || ""
    var cano = localStorage.getItem("cano") || ""
    var isSledCustomer = localStorage.getItem("isSledCustomer") == "true"
    var invoiceData = new InvoiceData();
    invoiceData.amount = this.totalamount;
    invoiceData.currency = "USD";
    invoiceData.bpno = bpno;
    invoiceData.cano = cano;
    invoiceData.cno = "";
    console.log(invoiceData)
    this.SOAPPaymentRequest.invoiceData.push(invoiceData);
    this.SOAPPaymentRequest.paymentMethod.bpno = bpno;
    this.SOAPPaymentRequest.isSledCustomer = isSledCustomer;
    let logTraceJSON: any = { 'eventSource': 'historicalPaymentProcessingSOAP', 'payload': this.SOAPPaymentRequest, 'invoiceData': JSON.stringify(this.SOAPPaymentRequest.invoiceData), 'ban': this.ban, 'email': this.azureData['emails'][0], 'amount': Number.parseFloat(this.totalamount), 'paymentMethodId': this.SOAPPaymentRequest.speedFrameToken };
    const headers = new HttpHeaders({
        'X-Log-Trace': JSON.stringify(logTraceJSON),
    });
    this.http.post(environment.serverURL + environment.pgURI + "payment/soap/pay", this.SOAPPaymentRequest, {headers}).pipe((res: any) => {
      console.log(res);
      this.paymentResposne = res;
      return this.paymentResposne;
    });
    return this.paymentResposne;
  }

  recurring(token:any,paymenttype:any,recurringFalg:any): Observable<any>{
    this.SOAPRecurringPaymentRequest.speedFrameToken = token;
    this.SOAPRecurringPaymentRequest.amount = 0;
    this.SOAPRecurringPaymentRequest.creditAccount = this.ban;
    this.SOAPRecurringPaymentRequest.recurring = recurringFalg;
    this.SOAPRecurringPaymentRequest.paymentMethod.paymentType = paymenttype;
    this.SOAPRecurringPaymentRequest.email = this.azureData['emails'][0];
    this.SOAPRecurringPaymentRequest.debitZip = this.zipcode;
    
    this.SOAPRecurringPaymentRequest.paymentMethod.bpno = this.ban;
    console.log("Environment URLs in Recurring", environment.serverURL, environment.pgURI);
    let logTraceJSON: any = { 'eventSource': 'recurringPaymentSOAP', 'payload': this.SOAPRecurringPaymentRequest, 'ban': this.ban, 'email': this.azureData['emails'][0], 'paymentMethodId': this.SOAPPaymentRequest.speedFrameToken };
    const headers = new HttpHeaders({
        'X-Log-Trace': JSON.stringify(logTraceJSON),
    });
    this.http.post(environment.serverURL+ environment.pgURI + "payment/soap/recurringPayment",this.SOAPRecurringPaymentRequest, {headers}).pipe((res:any)=>{
      console.log(res);
      this.paymentResposne= res;
      return this.paymentResposne;
    });
    return this.paymentResposne;
  }

  deleteRecurring(banNo:any, confirmationCode:any): Observable<any> {
    this.DeleteRecurringPaymentRequest.accountId = banNo;
    this.DeleteRecurringPaymentRequest.confirmationCode = confirmationCode;

    let logTraceJSON: any = { 'eventSource': 'deleteRecurringSchedule', 'payload': this.DeleteRecurringPaymentRequest, 'ban': banNo, 'confirmationCode': confirmationCode };
    const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Log-Trace': JSON.stringify(logTraceJSON),
    });
    const options = {
        headers: headers,
        body: this.DeleteRecurringPaymentRequest
    };
    console.log("Environment URLs in Delete Recurring", environment.serverURL, environment.pgURI);
    return this.http.delete(environment.serverURL+ environment.pgURI + "payment/schedule",options);

  }


}
